/* eslint-disable jsx-a11y/anchor-is-valid */
/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React, { useCallback } from "react";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip } from "@material-ui/core";

const ContactErrorDisplay = ({ contact, prop }) => {
	const getError = useCallback((contact, prop) => {
		return contact?.errors[prop] || "";
	}, []);

	const errorStyle = {
		color: "#d10000",
		display: "inline-block",
		fontSize: "11px",
	};
	return <span style={errorStyle}>{getError(contact, prop)}</span>;
};

/**
 * Read-only table of contacts used to show preview of external contacts
 */
export const ExternalContactsPreview = ({ parsedContacts }) => {
	const renderRow = useCallback((contact) => {
		return (
			<TableRow key={contact.contactId}>
				<TableCell>
					<span>{contact.fullName}</span>
					<ContactErrorDisplay contact={contact} prop="fullName" />
				</TableCell>
				<TableCell>
					<span>{contact.phone}</span>
					<ContactErrorDisplay contact={contact} prop="phone" />
				</TableCell>
				<TableCell>
					<span>
						{contact.tags.map((tag, i) => (
							<Chip key={tag + i} variant="outlined" size="small" label={tag} style={{ margin: "2px 5px 2px 0" }} />
						))}
					</span>
					<ContactErrorDisplay contact={contact} prop="tags" />
				</TableCell>
				<TableCell>
					<span>{contact.azureAdUserId}</span>
					<ContactErrorDisplay contact={contact} prop="azureAdUserId" />
				</TableCell>
			</TableRow>
		);
	}, []);

	return (
		<div>
			<TableContainer component={Paper} elevation={0}>
				<Table size="small">
					<TableHead>
						<TableRow>
							<TableCell>Name</TableCell>
							<TableCell>Phone #</TableCell>
							<TableCell>Tags</TableCell>
							<TableCell>Azure AD User ID</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{!parsedContacts.length ? (
							<TableRow>
								<TableCell colSpan={6} style={{ height: 60 }} align="center">
									No contacts found.
								</TableCell>
							</TableRow>
						) : (
							parsedContacts.map((contact) => renderRow(contact))
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	);
};
